'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fireGTMevent = undefined;

var _isomorphicHelpers = require('./isomorphic-helpers');

var fireGTMevent = exports.fireGTMevent = function fireGTMevent(gtmEvent, gtmInfo) {
  var dataLayer = !(0, _isomorphicHelpers.isServerSide)() && window && window.dataLayer || [];
  dataLayer.push({
    event: gtmEvent,
    info: gtmInfo || ''
  });
};